import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BehaviorService {
  constructor() {}

  public scrollToTheTop(): void {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
}
